module.exports = __webpack_public_path__ + "static/media/Light_House_Edited_Caroussel.d6fde12c.jpg";